if (!window.customElements.get("component-recently-products")) {
    class RecentlyViewedProducts extends HTMLElement {
        constructor() {
            super(...arguments);
            this.sectionID = 'section-recently-viewed';
        }

        connectedCallback() {
            this.defineElements();
            this.removeCurrentItem();
            this.loadProducts();
        }

        defineElements() {
            this.items = new Set(JSON.parse(localStorage.getItem("recently-viewed-products") || "[]"));
            this.section = this.closest('.shopify-section');
            this.tabContent = this.section.querySelector('[data-js-recently-tab-content]');
            this.tabHeaeder = this.section.querySelector('[data-js-recently-tab-header]');
        }

        removeCurrentItem() {
            if (this.hasAttribute("exclude-id")) {
                this.items.delete(
                    parseInt(this.getAttribute("exclude-id"))
                );
            }
        }

        createSearchQuery() {
            return Array.from(this.items.values(), (item) => `id:${item}`).slice(0, parseInt(this.getAttribute("products-count"))).join(" OR ");
        }

        createRequestUrl() {
            return `${Shopify.routes.root}search?type=product&q=${this.createSearchQuery()}&section_id=${this.sectionID}`
        }


        async loadProducts() {
            if (this.items.size) {
                const response = await fetch(this.createRequestUrl(), { priority: "low" });
                const content = new DOMParser().parseFromString(await response.text(), "text/html");
                this.renderContent(content);
            }
            else {
                if (this.tabContent) this.tabContent.remove();
                if (this.tabHeaeder) this.tabHeaeder.remove();
            }

        }

        renderContent(content) {
            const component = content.querySelector('component-recently-products');
            this.innerHTML = component.innerHTML;
            this.initSlider();
        }

        initSlider() {
            this.buttonPrev = this.querySelector('.custom-prev-button');
            this.buttonNext = this.querySelector('.custom-next-button');
            this.slider = this.querySelector('swiper-container');
            this.scrollbar = this.querySelector('.swiper-scrollbar');

            const swiperParams = {
                spaceBetween: 10,
                slidesOffsetBefore: 15,
                slidesOffsetAfter: 15,
                slidesPerView: 2.2,
                breakpoints: {
                    750: {
                        slidesPerView: 2.2,
                        spaceBetween: 10,
                        slidesOffsetBefore: 0,
                        slidesOffsetAfter: 15,
                    },
                    990: {
                        slidesPerView: 4,
                        spaceBetween: 10,
                        slidesOffsetBefore: 0,
                        slidesOffsetAfter: 15,
                    },
                    1400: {
                        slidesPerView: 4.5,
                        slidesOffsetBefore: 0,
                        slidesOffsetAfter: 0,
                        spaceBetween: 15,
                    },
                },
                navigation: {
                    nextEl: this.buttonNext,
                    prevEl: this.buttonPrev
                },
                scrollbar: {
                    el: this.scrollbar,
                    draggable: true,
                },
                on: {
                    init() {
                    }
                },
            };

            Object.assign(this.slider, swiperParams);

            this.slider.initialize();
        }

    }

    window.customElements.define("component-recently-products", RecentlyViewedProducts);
}

if (!window.customElements.get("component-purchased-slider")) {
    class componentPurchasedSlider extends HTMLElement {

        constructor() {
            super();

            this.selectors = {
                swiper: "swiper-container",
                prevEl: ".custom-prev-button",
                nextEl: ".custom-next-button",
                scroll: ".swiper-scrollbar"
            }

            this.slider = this.querySelector(this.selectors.swiper);
            this.buttonPrev = this.querySelector(this.selectors.prevEl);
            this.buttonNext = this.querySelector(this.selectors.nextEl);
            this.scrollbar = this.querySelector(this.selectors.scroll);
            this.initSlider();
            this.addListeners();
        }

        initSlider() {
            const swiperParams = {
                slidesPerView: 2.2,
                spaceBetween: 10,
                slidesOffsetBefore: 15,
                slidesOffsetAfter: 15,
                breakpoints: {
                    750: {
                        slidesPerView: 2.2,
                        spaceBetween: 10,
                        slidesOffsetBefore: 0,
                        slidesOffsetAfter: 15,
                    },
                    990: {
                        slidesPerView: 4,
                        spaceBetween: 10,
                        slidesOffsetBefore: 0,
                        slidesOffsetAfter: 15,
                    },
                    1400: {
                        slidesPerView: 4.5,
                        slidesOffsetBefore: 0,
                        slidesOffsetAfter: 0,
                        spaceBetween: 15,
                    },
                },
                navigation: {
                    nextEl: this.buttonNext,
                    prevEl: this.buttonPrev
                },
                scrollbar: {
                    el: this.scrollbar,
                    draggable: true,
                },
                on: {
                    init() {
                    }
                },
            };

            Object.assign(this.slider, swiperParams);

            this.slider.initialize();

        }

        addListeners() {
            document.addEventListener('shopify:section:reorder', () => this.initSlider());
            document.addEventListener('shopify:section:load', () => this.initSlider());
        }

    }

    window.customElements.define("component-purchased-slider", componentPurchasedSlider);
}
